import { useState, useEffect } from "react";
import quotesData from '../data/quotes.json';
import { Link } from 'react-router-dom';

import WeekViz from "./WeekViz";
import DevToggle from "./DevToggle";
import SportsToggle from "./SportsToggle";

export default function Nav() {
    // For random quote (stack 2)
    const [randomQuote, setRandomQuote] = useState(null);
    const [showQuote, setShowQuote] = useState(false);

    // Soccer/Basketball toggle state
    const [isPlaying, setIsPlaying] = useState('soccer');

    const handleSportsToggle = () => {
        setIsPlaying((prev) => (prev === 'soccer' ? 'basketball' : 'soccer'));
    };

    const maxLen = 40;

    const isSingleShortSentence = (str, maxLen) => {
        // Remove trailing whitespace and period
        const trimmed = str.trim().replace(/[.?!]+$/, '');
        // If there is a period/question/exclamation in the middle, it's not single sentence
        const isSingle = !/[.?!]/.test(trimmed.slice(0, -1));
        return isSingle && trimmed.length <= maxLen;
    };

    const displayRandomQuote = () => {
        const filteredQuotes = quotesData.filter(q => isSingleShortSentence(q.content, maxLen));
        if (filteredQuotes.length === 0) {
            setRandomQuote('No suitable short quotes found.');
            setShowQuote(true);
            return;
        }
        const randomIndex = Math.floor(Math.random() * filteredQuotes.length);
        setRandomQuote(filteredQuotes[randomIndex].content);
        setShowQuote(true);
    };
        // Touch state for swipe left/right
        const [touchStartX, setTouchStartX] = useState(null);
        const [touchEndX, setTouchEndX] = useState(null);

        const minSwipeDistance = 40;

        // Handle swipe left/right
        const onTouchStart = (e) => {
            setTouchEndX(null);
            setTouchStartX(e.targetTouches[0].clientX);
        };
        const onTouchMove = (e) => {
            setTouchEndX(e.targetTouches[0].clientX);
        };
        const onTouchEnd = () => {
            if (touchStartX === null || touchEndX === null) return;
            const distance = touchStartX - touchEndX;
            if (Math.abs(distance) > minSwipeDistance) {
                if (distance > 0) {
                    // Swipe left
                    setStack((prev) => (prev + 1) % 4);
                } else {
                    // Swipe right
                    setStack((prev) => (prev - 1 + 4) % 4);
                }
            }
        };
    const home = { href: "/", label: "imajin.dev", color : "red" };

    const links = [
        { href: "/about", label: "About", color : "var(--ptR)"  },
        // { href: "/products", label: "PRODUCTS", color : "lime"  },
        { href: "/works", label : "Works", color : "var(--ptG)" },
        // { href: "/series", label : "Series", color : "blue" },
        { href: "/blog", label: "Blog", color : "var(--ptB)" },
        { href: "/library", label: "Library", color : "var(--ptA)" },
    ];

    const [width, setWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(null);

    const [stack, setStack] = useState(0);


    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setIsMobile(width < 768);
    }, [width]);

    // Show random quote when stack switches to 2
    useEffect(() => {
        if (stack === 2) {
            displayRandomQuote();
        }
    }, [stack]);

    return (
        <div
            className = "navContainer"
            {...(isMobile ? {
                onTouchStart,
                onTouchMove,
                onTouchEnd
            } : {})}
        >
            <div style = { { flex : 1, margin : 0, padding : 0, height : "40px", position : "relative" } }>
                
                <Link to = { home.href } style = { { boxSizing : "border-box", cursor : "pointer", position : "absolute", top : 0, left : 0 } } onClick = { () => setStack(0) }>
                    {/* <p className = "navHome">{ home.label }</p> */}
                    <img className = "navLogoImg" src = "/assets/navLogo.png" style = { { width : "40px", height : "40px" } }/>
                </Link>
                
                { isMobile && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent : "flex-start", gap: 0,
                        bottom : "-6px",left : "4px", position : "absolute", zIndex : 2 }}>
                        {[0, 1, 2, 3].map((i) => (
                            <img
                                key={i}
                                src = { `/assets/stackIcon${i}.png` }
                                style={{
                                    display: 'block',
                                    width: '10px',
                                    height: '10px',
                                    opacity: stack === i ? 0.72 : 0.16,
                                    transition: 'opacity 0.2s',
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>

            {/* Nav content changes by stack */}
            {stack === 0 && (
                <div className = "nav">
                    { links.map( ( link, index ) => (
                        <Link key = { index } to = { link.href } className = "navLink" style = { { '--hover-color' : link.color } }>
                            <p>{ link.label }</p>
                        </Link>
                    ))}

                    { !isMobile && <WeekViz/> }
                </div>
            )}
            { stack === 1 && (
                <div style={{ width : "50vw", display : "flex", justifyContent: 'flex-end', marginRight : "20px" }}>
                    <WeekViz isMobile = { true }/>
                </div>
            )}
            { stack === 2 && showQuote && randomQuote && (
                <div
                    className = "nav"
                    style={{
                        overflow: 'hidden',
                        display : "flex",
                        flexDirection : "column",
                        gap : "4px",
                        alignItems : "flex-end",
                        justifyContent : "center",
                    }}
                    onClick={displayRandomQuote}
                >
                    <div style = { { display : "flex", flexDirection : "row", alignItems: "center", gap : "2px" } }>
                        <img src = "/assets/quotesLogo.png" style = { { width : "16px", height : "16px", marginTop : "2px" } } />
                        <p style = { { fontSize : "9px", color : "var(--black56)" } }>Quotes</p>
                    </div>
                    <p
                        key={randomQuote}
                        style={{
                            fontSize : "var(--font-size-teeny)",
                            fontFamily: 'var(--font-Source)',
                            color : "var(--black80)",
                            fontWeight : "600",
                            lineHeight : "120%",
                            animation: 'blurFade2 1s ease-out',
                            flex: 1,
                            width: '100%',
                            height : "100%",
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            margin: 0,
                            textAlign: 'right',
                            whiteSpace: 'pre-line',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {randomQuote}
                    </p>

                    <style>{`
                        @keyframes blurFade2 {
                            0% {
                                opacity: 0.1;
                                filter: blur(4px);
                            }
                            100% {
                                opacity: 1;
                                filter: blur(0px);
                            }
                        }
                    `}</style>
                </div>
            )}
            { stack === 3 && (
                <div style={{ justifyContent: 'flex-end', alignItems: '', display: 'flex', width: '100%', marginRight : '16px', gap : "8px" }}>
                    <SportsToggle/>
                   <DevToggle/>
                </div>
            )}
        </div>
    );
}